// extracted by mini-css-extract-plugin
export var infoItem = "_rk-2";
export var title = "_rk-0";
export var value = "_rk-1";